import { Component, OnInit } from '@angular/core'
import { FormGroup, FormBuilder } from '@angular/forms'
import { retry } from 'rxjs/operator/retry'
import { AuthorizeService } from '../../service/authorize.service'

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})
export class StatusComponent implements OnInit {
  status: FormGroup
  statusId: Number
  departmentId: Number
  enableEditStatus: Boolean = true
  statusList: Array<Object> = []
  departmentList: Array<Object> = []
  isCreateNewCase: Boolean = true
  constructor(
    private fb: FormBuilder,
    private authorization: AuthorizeService
  ) {}

  ngOnInit() {
    this.status = this.fb.group({
      caseStatus: [''],
      department: ['']
    })
  }

  async initial() {
    const departmentId = this.authorization.getUserDepartment()
    if (this.isCreateNewCase) {
      this.departmentList = this.departmentList.filter(
        x => x['id'] !== departmentId
      )
      if (this.departmentList.length > 0) {
        this.departmentId = this.departmentList[0]['id']
      }
    }
    this.status.get('caseStatus').setValue(this.statusId)
    this.status.get('department').setValue(this.departmentId)

    if (!this.enableEditStatus) {
      this.status.get('caseStatus').disable()
      this.status.get('department').disable()
    }
  }

  get isForward(): Boolean {
    const result = this.statusList.find(
      x =>
        Number(x['id']) === Number(this.status.get('caseStatus').value) &&
        x['flag'] === 'F'
    )
    return result ? true : false
  }

  get currentStatus(): Object {
    return this.status.get('caseStatus').value
  }

  get currentDepartment(): Object {
    if (this.isForward) {
      return this.status.get('department').value
    }
    return null
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/status/status.component.ts